import styled, { css } from "styled-components";

import Props from "./props";
import React from "react";

const Input: React.FC<Props> = ({ placeholder, value, onChange, isSearchPage }) => {
    return (
        <Styled
            isSearchPage={isSearchPage}
            type="search"
            placeholder={placeholder}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        />
    );
};

export default Input;

interface StyledProps {
    placeholder: string;
    value: string;
    isSearchPage: boolean;
}

const Styled = styled.input<StyledProps>`
    outline: none;
    border: none;
    height: 2.8rem;
    width: 30%;
    border-radius: 2rem;
    padding: 0 1rem;
    line-height: 3.5rem;
    transition: all 0.6s ease;
    left: 60%;
    transform: translateX(-50%);
    position: absolute;
    z-index: 1;
    background-image: url(${(props: any) => props.theme.staticPath + "static/img/search.svg"});
    background-repeat: no-repeat;
    padding-left: 2.2rem;
    background-size: 1.5rem;
    background-position: 0.4rem center;
    &:focus {
        left: 5rem;
        width: 100%;
        height: 4.5rem;
        border-radius: 0;
        transform: translateX(0);
        padding-left: 2.6rem;
        background-position: 0.6rem center;
    }
    ${({ isSearchPage }) =>
        isSearchPage &&
        css`
            left: 5rem;
            width: 100%;
            height: 4.5rem;
            border-radius: 0;
            transform: translateX(0);
            padding-left: 2.6rem;
            background-position: 0.6rem center;
        `}
`;
